import { put, call, take, fork } from 'redux-saga/effects'
import { deleteCollectionService } from 'src/api/collection'

import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'
import { DELETE_COLLECTION } from 'src/reducers/collection/type'
import { deleteCollectionSuccess } from 'src/reducers/collection/action'
/**
 *
 * @param {*} payload
 */
function* deleteCollectionSagaFlow(payload) {
  try {
    const { id, callback } = payload
    yield call(deleteCollectionService, id)

    yield put(deleteCollectionSuccess(id))
    yield put(operationSuccess())

    callback(id)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* deleteCollectionWatcher() {
  while (true) {
    const action = yield take(DELETE_COLLECTION)
    const { payload } = action

    yield fork(generalSaga, deleteCollectionSagaFlow, payload)
  }
}
